import React, { useState, useEffect } from "react";
import { Alert } from "reactstrap";

const NoInternet = () => {
  const [online, setOnline] = useState(window.navigator.onLine);
  const [showReconnected, setShowReconnected] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setOnline(true);
      setShowReconnected(true);
      // Hide the "reconnected" message after 3 seconds
      const timer = setTimeout(() => setShowReconnected(false), 3000);
      return () => clearTimeout(timer);
    };

    const handleOffline = () => {
      setOnline(false);
      setShowReconnected(false);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  if (online && !showReconnected) return null;

  return (
    <div 
      style={{ 
        position: "fixed", 
        bottom: "20px", 
        right: "20px", 
        zIndex: 9999, 
        maxWidth: "350px" 
      }}
    >
      {!online ? (
        <Alert color="warning" className="shadow-sm mb-0">
          <strong>Offline Mode:</strong> You are currently offline. Showing cached data; changes will sync when reconnected.
        </Alert>
      ) : (
        showReconnected && (
          <Alert color="success" className="shadow-sm mb-0">
            <strong>Back online!</strong> Syncing your data...
          </Alert>
        )
      )}
    </div>
  );
};

export default NoInternet;